import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const WhatIsInvestmetTypeModal = ({
  isShow,
  hide,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4">
          <div className="flex flex-row">
            <div className="text-lg font-bold">現在の運用タイプとは</div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="text-sm pt-4">
            目標のポートフォリオを、自分の好みや思惑を反映した配分にカスタマイズできます。
          </div>
          <div
            className="flex justify-center text-gray-500 mt-6 mb-2 mx-1 p-2 text-sm cursor-pointer"
            onClick={hide}>
            閉じる
          </div>
        </div>
      </Modal2>
    </>
  );
};
